
var wfT = window.wfI18n || function(message, values = []) { return message.replace(/\{(\d+)\}/g, (_, i) => String(values[Number(i)] ?? '')); };
var wfH = function(message, values = []) { return wfT(message, values).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); };
/** Connect the homepage support action to the existing Shopify chat. */
class WFHomeSupport extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.openChat);

    customElements.whenDefined('shopify-chat').then(() => {
      if (!this.isConnected) return;

      const chat = document.querySelector('shopify-chat');
      if (typeof chat?.show !== 'function') return;

      this.querySelectorAll('[data-support-ai], [data-support-chat]').forEach((element) => {
        element.hidden = false;
      });
    });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.openChat);
  }

  openChat = (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-support-chat]')) return;

    const status = this.querySelector('[data-support-status]');
    const chat = document.querySelector('shopify-chat');

    try {
      if (typeof chat?.show !== 'function') throw new Error(wfT("Chat is unavailable"));
      chat.show();
      if (status) status.hidden = true;
    } catch {
      if (status) status.hidden = false;
    }
  };
}

if (!customElements.get('wf-home-support')) {
  customElements.define('wf-home-support', WFHomeSupport);
}
